// extracted by mini-css-extract-plugin
module.exports = {"Component":"PlaceDetail_Component__3RaCb","EditButton":"PlaceDetail_EditButton__3uzbW"};